import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToDHM'
})
export class SecondsToDHMPipe implements PipeTransform {

  transform(value: number,): string {
    const days = Math.floor(value / (3600 * 24));
    const hours = Math.floor((value % (3600 * 24)) / 3600);
    const minutes = Math.floor((value % 3600) / 60);

    let result = '';
    if(days > 0) {
      result += days  + 'd ';
    }
    if (hours > 0) {
      result += hours + 'h ';
    }
    if (minutes > 0) {
      result += minutes + 'm';
    }
    return result.trim();
  }

}
